/**
 * The interview details route is lazy, so its chunk is only fetched once the
 * user clicks. On staging that chunk took ~1.4s to arrive and no request on the
 * page could start until it had — the largest single cost of opening an
 * interview. Kick it off on hover instead.
 */
let requested = false;

export const preloadInterviewDetailsRoute = (): void => {
  if (requested) return;
  requested = true;
  import('@/pages/interviews-revamp/details').catch(() => {
    // A failed preload must not surface — React.lazy retries on navigation.
    requested = false;
  });
};
